.DefaultButtonControl
    background-color: rgb($globalButtonBackgroundPrimary)
    color: rgb($globalButtonFontPrimary)
    stroke: rgb($globalButtonFontPrimary)
    &.IconDisabled
        stroke: rgb($globalButtonFontTertiary)
    &.ButtonInput
        &:hover
            background-color: rgb($globalButtonBackgroundSecondary)
        &:focus
            background-color: rgb($globalButtonBackgroundSecondary)
.DefaultButtonControlActive
    &:hover
        background: rgb($globalButtonBackgroundSecondary) radial-gradient(circle, transparent 1%, rgb($globalButtonBackgroundTertiary) 1%) center/15000%
    &:active
        background-color: rgb($globalButtonBackgroundPrimary)
.DefaultDivider
    background: rgb($globalButtonFontPrimary)

.InverseButtonControl
    background: rgb($globalSettingsBackgroundPrimary)
    color: rgb($globalSettingsFontPrimary)
    stroke: rgb($globalSettingsFontPrimary)
    &.IconDisabled
        stroke: rgb($globalSettingsFontTertiary)
    &.ButtonInput
        &:hover
            background-color: rgb($globalSettingsBackgroundSecondary)
        &:focus
            background-color: rgb($globalSettingsBackgroundSecondary)
.InverseButtonControlActive
    &:hover
        background: rgb($globalSettingsBackgroundSecondary) radial-gradient(circle, transparent 1%, rgb($globalSettingsBackgroundTertiary) 1%) center/15000%
    &:active
        background-color: rgb($globalSettingsBackgroundPrimary)
.InverseDivider
    background: rgb($globalSettingsFontPrimary)

.NotAvailableButtonControl
    background: rgb($globalSettingsStrokePrimary)
    color: rgb($globalSettingsBackgroundPrimary)
    stroke: rgb($globalSettingsBackgroundPrimary)
    &.IconDisabled
        stroke: rgb($globalSettingsBackgroundTertiary)
    &.ButtonInput
        &:hover
            background-color: rgb($globalSettingsStrokeSecondary)
        &:focus
            background-color: rgb($globalSettingsStrokeSecondary)
.NotAvailableButtonControlActive
    &:hover
        background: rgb($globalSettingsStrokeSecondary) radial-gradient(circle, transparent 1%, rgb($globalSettingsStrokeTertiary) 1%) center/15000%
    &:active
        background-color: rgb($globalSettingsStrokePrimary)
.NotAvailableDivider
    background: rgb($globalSettingsBackgroundPrimary)

.ControlsContainer
    opacity: 0
    height: 100%
    display: flex
    flex-direction: row
    justify-content: center
    align-items: center
    box-sizing: border-box
    .IconsContainer
        height: 24px
        width: 44px
        margin-left: 4px
        display: flex
        flex-direction: row
        justify-content: space-between
        gap: 1px
        .Icons
            height: calc(100% + 1px)
            width: calc(100% + 1px)
            display: flex
            align-items: center
            justify-content: center
            cursor: pointer
            background-position: center
            outline: none
            border-radius: $globalButtonRounding
            transition: background 0.4s
            &:active
                background-size: 100%
                transition: background 0s
        .IconDisabled
            cursor: default
            transition: opacity 0s, stroke 0s, background 0s

    .Divider
        height: 24px
        width: 1px
        margin: 0 2px

.InfoNumber
    width: 28px
    margin: 0 5px
    font-size: 14px
    font-weight: 400
    text-align: center
    cursor: default

.Spacer
    width: 5px

.ButtonInput
    width: 28px
    height: 27px
    border-radius: $globalButtonRounding
    padding: 0
    margin: 0
    outline: none
    border: none
    line-height: 1em
    text-align: center
    font-size: 14px
    background-position: center
    &:focus
        outline: none
